module.exports = __webpack_public_path__ + "static/img/application10-4.a878c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application10-4.jpg
// module id = H0D6
// module chunks = 0